import { render, staticRenderFns } from "./EquipmentAccessories.vue?vue&type=template&id=ba342406"
import script from "./EquipmentAccessories.vue?vue&type=script&lang=js"
export * from "./EquipmentAccessories.vue?vue&type=script&lang=js"
import style0 from "./EquipmentAccessories.vue?vue&type=style&index=0&id=ba342406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports